import React, {
    ComponentType,
    createContext,
    ImgHTMLAttributes,
    PropsWithChildren,
    useContext,
} from 'react';

export interface TImageViewConfig
    extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'sizes'> {
    retries?: number;
    renderFallback?: ComponentType<PropsWithChildren<ImgHTMLAttributes<HTMLImageElement>>>;
}

const _context = createContext<TImageViewConfig>({});
_context.displayName = 'ImageViewContext';

export function useImageViewConfig() {
    return useContext(_context);
}

/**
 * Configure all descendant `<ImageView>`s. Most of the properties of `ImageView` are supported.
 * It will inherit values from ancestor config unless `freshScope` is true.
 */
export function ImageViewConfig({
    children,
    freshScope,
    ...config
}: PropsWithChildren<
    Partial<TImageViewConfig> & {
        /** Should it drop values from ancestor config. */
        freshScope?: boolean;
    }
>) {
    const parentValue = useImageViewConfig();
    const value = { ...(freshScope ? {} : parentValue), ...config };
    const ImageViewProvider = _context.Provider;

    return <ImageViewProvider value={value}>{children}</ImageViewProvider>;
}
